export interface ChurchFormProps {
  // Outputs
  mode: 'add' | 'edit';
  formState: ChurchFormState;
  isLoading: boolean;
  // Inputs
  userUpdatedFormState: React.Dispatch<React.SetStateAction<ChurchFormState>>;
  userClickedCancel: () => void;
  /**
   * Called when the user clicks the "Add Section" button
   * to indicate that they want to add a new section to the mission statement
   **/
  userClickedSaveSection: () => void;
}

export interface ChurchFormState {
  id: string;
  name: string;
  externalId: string;
  address: string;
  phone: string;
  logo: string;
  created: string;
}

export const churchInitialFormState: ChurchFormState = {
  id: '',
  name: '',
  externalId: '',
  address: '',
  phone: '',
  logo: '',
  created: '',
};
